function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityAssetRemoved = function SvgActivityAssetRemoved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.75,
    height: 13.937,
    viewBox: "0 0 13.75 13.937"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m736.484 654.643-4.534-4.6 4.535-4.6-2.332-2.366-4.534 4.6-4.534-4.6-2.332 2.366 4.534 4.6-4.534 4.6 2.332 2.367 4.534-4.6 4.533 4.6Z",
    style: {
      fill: "#403f40",
      fillRule: "evenodd"
    },
    transform: "translate(-722.75 -643.063)"
  }));
};
export default SvgActivityAssetRemoved;